import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flatpickr"
export default class extends Controller {
  connect() {
    // Initialize Flatpickr on date fields
    this.initializeFlatpickr()
  }

  disconnect() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy()
    }
  }

  initializeFlatpickr() {
    // Find all elements with data-flatpickr attribute
    const dateFields = this.element.querySelectorAll('[data-flatpickr="true"]')
    
    dateFields.forEach(field => {
      if (!field._flatpickr) { // Avoid double initialization
        field._flatpickr = window.flatpickr(field, {
          dateFormat: "m/d/Y",
          allowInput: false, // Prevent manual typing
          clickOpens: true,
          onChange: (selectedDates, dateStr, instance) => {
            // Trigger change event for Turbo field updates
            field.dispatchEvent(new Event('change', { bubbles: true }))
          }
        })
      }
    })
  }
}